<div class="my-account-container">
    <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
    <h4>{{'MY_INFORMATION'|translate}}
        <app-user-crud style="float:right;margin-top:-10px;" [userId]="userId" [mode]="update" *ngIf="authenticationService.userHasRoleAdmin()"></app-user-crud>
    </h4>
    <div class="modal-body formModal">

        <div><b [innerHtml]="'INFORMATION'|translate">Information</b></div>
        <mat-form-field class="readonly">
            <input matInput [placeholder]="'LASTNAME' | translate" [value]="user.lastname" [readonly]="true">

        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'FIRSTNAME' | translate" [value]="user.firstname" [readonly]="true">

        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'PHONE' | translate" [value]="user.phone" [readonly]="true">

        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'EMAIL' | translate" [value]="user.email" [readonly]="true">

        </mat-form-field>

        <mat-form-field class="readonly">
            <mat-select [value]="user.lang" [placeholder]="'LANG' | translate" [disabled]="true">
                <mat-option value="fr">fr</mat-option>
                <mat-option value="en">en</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-slide-toggle [(ngModel)]="user.active" [disabled]="true">{{user.active ? 'Active
            user' : 'Inactive user'}}
        </mat-slide-toggle>

        <div><b [innerHtml]="'ROLES'|translate">Roles</b></div>

        <mat-chip-list>
            <mat-chip *ngFor="let role of user.roles">{{getRoleDisplayed(role)}}</mat-chip>
        </mat-chip-list>

    </div>
</div>
<div class="my-account-container my-account-container-border">
    <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
    <h4>{{'MY_LEVEL'|translate}}
        <app-level-crud style="float:right;margin-top:-10px;" [levelId]="levelId" [mode]="update" *ngIf="authenticationService.userHasRoleAdmin()"></app-level-crud>
    </h4>
    <div class="modal-body formModal">


        <div><b [innerHtml]="'INFORMATION'|translate">Information</b></div>
        <mat-form-field class="readonly">
            <input matInput [placeholder]="'NAME' | translate" [value]="level.name" [readonly]="true">

        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'EMAIL' | translate" [value]="level.email" [readonly]="true">

        </mat-form-field>

        <mat-form-field class="readonly">
            <mat-select [value]="level.lang" [placeholder]="'LANG' | translate" [disabled]="true">
                <mat-option value="fr">fr</mat-option>
                <mat-option value="en">en</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-slide-toggle [(ngModel)]="level.active" [disabled]="true">{{level.active ? 'Active levels' : 'Inactive
            level'}}
        </mat-slide-toggle>


        <div><b [innerHtml]="'ADDRESS'|translate">Address</b></div>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'ADDRESS1' | translate"
                   [value]="level.description.street" [readonly]="true">
        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'ADDRESS2' | translate"
                   [value]="level.description.supplement" [readonly]="true">
        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'ZIPCODE' | translate" [value]="level.description.zipcode"
                   [readonly]="true">
        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'CITY' | translate" [value]="level.description.city"
                   [readonly]="true">
        </mat-form-field>

        <mat-form-field class="readonly">
            <input matInput [placeholder]="'COUNTRY' | translate"
                   [value]="level.description.country" [readonly]="true">
        </mat-form-field>

        <mat-form-field style="width:90%" class="readonly">
            <input matInput [placeholder]="'NOTES' | translate" [value]="level.description.notes"
                   [readonly]="true">
        </mat-form-field>
    </div>

</div>
